module.exports = function(app) {
	'use strict';
	app.controller('pages.assistEmployees.groupContracts', ['$state', '$scope', 'sessionData','services',
		function ($state, $scope, sessionData, services) {

			$scope.feedback = {};
            $scope.groupEmail={value:''};
            $scope.bEmailOptIn =false;

			$scope.sidebar = { breadCrumb: {} };
			var crumbs = {
				groupContracts: {
					title: sessionData.employerInfo.brandName == '6010' ? 'Master Group Contracts' : 'Group Contracts',
					state: 'assistEmployees.groupContracts'
				},
				assistEmployees: {
					title: 'Assist Employees',
					state: 'assistEmployees'
				}
			};

			var breadCrumb = $scope.sidebar.breadCrumb;

			if ($state.previous.name === 'assistEmployees') {
				breadCrumb.primary = crumbs.assistEmployees;
				breadCrumb.secondary = crumbs.groupContracts;
			}
			else {
				breadCrumb.primary = crumbs.groupContracts;
			}


            $scope.groupContracts = function (document) {

                services.eprsvc.cmodDocument().fetch(document).then(function (response) {
                    if(response){
                        console.log(response);
                    }

                })

            }

            $scope.objFiltering = {
				orderBy: 'groupNumber',
				reverse: false,
				titles: [
					{
						name: 'Group Number',
						dataKey: 'groupNumber'
					}


				],
				arrItems: []
			};

			$scope.groupContractArray={

				order:'masterGroupContracts',
				reverse:true,
                titles: [
                    {
                        name: 'Plan Name / Group Number',
                        dataKey: 'masterGroupContracts'
                    },
                    {
                        name: 'Riders/Addendum(s)',
                        dataKey: 'riders'
                    }
],
                    arrItems : []

			};
            if(sessionData.employerInfo.brandName == '6010'||sessionData.employerInfo.brandName == '3002' || sessionData.employerInfo.brandName == '3003'|| sessionData.employerInfo.brandName == '6008'||sessionData.employerInfo.brandName == '6009'
                ||sessionData.employerInfo.brandName == '6011'||sessionData.employerInfo.brandName == '6012'){
                $scope.groupContractArray.titles[0].name = 'Plan Name / Group Number';
                $scope.groupContractArray.titles.splice(1,1);
            }


            if(sessionData.employerInfo.brandName == '9001' || sessionData.employerInfo.brandName == '9002' || sessionData.employerInfo.brandName == '9009' || sessionData.employerInfo.brandName == '9010'||
                sessionData.employerInfo.brandName == '9011'||sessionData.employerInfo.brandName == '9012' || sessionData.employerInfo.brandName == '9010' ||sessionData.employerInfo.brandName == '6002'){
                $scope.bEmailOptIn =true;
            }

            if( $scope.bEmailOptIn){
                $scope.chkGroupEmail = function(){
                    services.eprsvc.emailGroupContracts().getData();
                }
            }
        }
	]);
};

